<template>
  <div>
    <div v-if="searchable && searchPlace === 'top'" class="search-con search-con-top">
      <Select v-model="searchKey" class="search-col">
        <Option v-for="item in arearIndexs" :value="item.key" :key="`search-col-${item.key}`">{{ item.title }}
        </Option>
      </Select>
      <Input @on-change="handleClear" clearable placeholder="输入关键字搜索" class="search-input" v-model="searchValue" />

      <Button @click="handleSearch" class="search-btn" type="primary" icon="ios-search">
        搜索</Button>
      <Button @click="reload" class="search-btn" type="primary">
        刷新列表</Button>
      <!-- <Button @click="getListBynote()" class="search-btn" type="warning">
            我的跟踪</Button> -->

      <Button @click="getBlackList" class="search-btn black-button" type="primary">
        我的黑名单</Button>
      <!-- <div> -->
      <Checkbox class="refresh" @on-change="handleSearch" v-model="isAutoRefreshed">开启按区域搜索自动刷新功能(刷新频率2分钟)</Checkbox>
      <!-- </div> -->
    </div>
    <Table :loading="loading" :border="showBorder" :stripe="showStripe" :show-header="showHeader"
      :height="fixedHeader ? 500 : ''" :size="tableSize" :data="tableData" :columns="tableColumns"
      :highlight-row="highlightRow" :editable="editable" :searchable="searchable" :searchPlace="searchPlace"
      @on-select="selectme" @on-select-cancel="selectme" @on-select-all="selectme" tooltip-theme="dark" ref="selection"
      :show-footer="showFooter">
      <template slot-scope="{ row, index }" slot="note">
        <Input type="text" v-model="editNote" v-if="editIndex === index" />
        <span v-else>{{ row.note }}</span>
      </template>

      <template slot-scope="{ row, index }" slot="action">
        <Button type="primary" size="small" style="margin-right: 5px" class="isclick-btn" @click="getLink(row.link)">
          详情 </Button>
        <Button style="margin-right: 5px" type="warning" size="small" @click="getMobile(row)"
          v-show="!row.phone">获取虚拟号</Button>
        <Button style="margin-right: 5px" type="error" size="small" v-show="row.phone"
          @click="fixMobile(row)">修改手机号</Button>

        <!-- v-show="row.user_name && row.user_name == $store.state.user.userName" -->
        <!-- <Button
          type="warning"
          size="small"
          v-if="editIndex === index"
          @click="notesave(row)"
          >保存</Button
        >
        <Button
          v-else-if="tableType != 'black'"
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="noteedit(row, index)"
          >跟踪</Button
        > -->

        <Button type="primary" size="small" style="margin-right: 5px" @click="selectme(row)"
          v-if="!row.selected">保护</Button>
        <Button type="error" size="small" style="margin-right: 5px" v-if="row.selected">已保护</Button>

        <Button type="primary" class="black-button" size="small" style="margin-right: 5px"
          v-if="tableType != 'black' && Number($store.state.user.lv) < 9" @click="blacksave(row, index)">拉黑</Button>

        <Button type="primary" class="black-button" size="small" style="margin-right: 5px"
          v-if="tableType != 'black' && Number($store.state.user.lv) > 8" @click="blacksaveDel(row, index)">回收</Button>

        <Button type="primary" class="black-button" size="small" style="margin-right: 5px" v-if="tableType == 'black'"
          @click="unblacksave(row, index)">复活</Button>
        <!-- <Button type="error"
                size="small"
                @click="remove(index)">Delete</Button> -->
      </template>
    </Table>

    <div style="margin: 10px; overflow: hidden">
      <div style="float: left">
        <!-- <Button @click="handleSelectAll(true)">批量领取</Button>
        <Button @click="handleSelectAll(false)">取消批量领取</Button> -->
      </div>
      <div style="float: right" v-if="showFooter">
        <Page :total="infoTotal" :page-size="rowNums" :current="curpage" show-total show-sizer show-elevator
          v-if="tableType == 'default' || tableType == 'search'" @on-page-size-change="changePageSize"
          @on-change="changePage"></Page>
      </div>
    </div>

    <Modal v-model="showFixPhone" :title="`手机号纠错修改(当前手机号：${curRow.phone})`" @on-ok="onOk" @on-cancel="onCancel">
      <div class="mobile-fixed">
        <Input type="text" v-model="formInline.mobile" placeholder="请输入新手机号" />
      </div>

      <Timeline style="margin-top: 20px;">
        <TimelineItem v-for="(item, index) in mobileHistoryList" :key="item.id">
          <p class="time" :class="{ red: index == 0 }">
            更新时间：{{ item.update_time }}
          </p>
          <p class="content" :class="{ red: index == 0 }">
            更新人：{{ item.user }}
          </p>
          <p class="content" style="color:red" v-if="index == 0">
            当前手机号：{{ item.mobile }}
          </p>
          <p class="content" v-else>历史手机号：{{ item.mobile }}</p>
        </TimelineItem>
      </Timeline>
    </Modal>
  </div>
</template>

<script>
import '_c/caijisystem/tables/search.less'
import expandRow from '_c/caijisystem/tables/table-expand.vue'
import { getMobile, saveMobile, getFixList, check58Call58 } from '@/api/data'
export default {
  name: 'list2',
  components: {
    expandRow
  },
  data() {
    return {
      mobileHistoryList: [],
      ruleInline: {},
      formInline: {},
      curRow: {},
      showFixPhone: false,
      tableData: [],
      sourceFilter: [
        {
          label: '58同城',
          value: '1'
        },
        {
          label: '赶集网',
          value: '2'
        }
      ],
      timeFilter: [],
      Areafilters: [],
      showBorder: true, // 显示表格列边框
      showStripe: true, // 显示斑马线样式
      showHeader: true, // 显示表头
      showIndex: true, // 显示索引序号
      showExpand: false, // 显示简要介绍
      showCheckbox: false, // 显示复选框/
      showNoteTime: false, // 显示备注时间
      fixedHeader: false, // 固定表头
      highlightRow: true, // 高亮选择的行
      searchable: true,
      searchPlace: 'top',
      searchKey: '',
      searchValue: '',
      editIndex: -1,
      editNote: '',
      editable: true, // 全局设置是否可编辑

      loading: false,
      // tooltip: true,
      tableSize: 'small',
      showFooter: true,

      fromPage: 1,
      rowNums: 50,
      infoTotal: 0,
      isClicked: true,

      tableType: 'default',
      isAutoRefreshed: false,
      refreshTime: 120000,
      mobile: '',
      newMobile: ''
    }
  },
  computed: {
    arearIndexs() {
      let tables = this.tableColumns
      let newTableColumns = []

      for (let i = 0; i < tables.length; i++) {
        let item = tables[i]
        console.log('item-------------------------', item)
        if (
          item.hasOwnProperty('key') &&
          item.key !== 'note' &&
          item.key !== 'noteTime' &&
          item.key !== 'time'
        ) {
          newTableColumns.push(tables[i])
        }
      }

      return newTableColumns
    },
    curpage() {
      return this.fromPage
    },
    tableColumns() {
      let columns = []
      // eslint-disable-next-line no-unused-vars
      let gettime = this.gettime
      if (this.showCheckbox) {
        columns.push({
          type: 'selection',
          width: 60,
          align: 'center'
        })
      }
      if (this.showIndex) {
        columns.push({
          type: 'index',
          width: 50,
          align: 'center'
        })
      }
      if (this.showExpand) {
        columns.push({
          type: 'expand',
          width: 60,
          align: 'center',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            })
          }
        })
      }

      columns.push({
        title: '店面图',
        key: 'pic',
        width: '125',
        minWidth: '120',
        align: 'center',
        render: (h, params) => {
          if (params.row.pic) {
            return h('img', {
              attrs: {
                src: params.row.pic
              },
              style: {
                width: '120px',
                height: '90px'
              }
            })
          } else {
          }
        }
      })
      columns.push({
        title: '发布时间',
        key: 'time',
        sortable: false,
        width: 150,
        align: 'center',
        // eslint-disable-next-line no-dupe-keys
        sortable: true
        // filters: this.timeFilter,
        // filterMethod (value, row) {
        //   return gettime(value, row);
        //   // return row.time.indexOf(value) > -1;
        // }
      })
      columns.push({
        title: '标题',
        key: 'title',
        width: 'auto',
        minWidth: 220
      })
      // columns.push({
      //   title: 'LINK',
      //   key: 'link',
      //   width: '200'
      // });

      columns.push({
        title: '区域',
        key: 'area',
        sortable: false,
        width: 'auto',
        minWidth: 180,
        align: 'center'

        // filters: this.Areafilters,
        // filterMultiple: false,
        // filterMethod (value, row) {
        //   console.log('row', row.area);
        //   if (row.area.indexOf(value) > -1) {
        //     return row.area;
        //   }
        // }
      })
      columns.push({
        title: '手机号',
        key: 'phone',
        width: 160,
        align: 'center',
        render: (h, params) => {
          return h('div', [
            h(
              'span',
              {
                style: {
                  color: '#f50',
                  fontSize: '16px',
                  fontWeight: 800
                }
              },
              params.row.phone
            )
          ])
        }
      })
      // if (Number(this.$store.state.user.lv) > 8) {
      columns.push({
        title: '编辑',
        key: 'user_name',
        width: 80,
        align: 'center'
        // render: (h, params) => {
        //   return h("div", [
        //     h(
        //       "span",
        //       {
        //         style: {
        //           color: "#f50",
        //           fontSize: "16px",
        //           fontWeight: 800
        //         }
        //       },
        //       params.row.user_name
        //     )
        //   ]);
        // }
      })
      // }
      // columns.push({
      //   title: "备注",
      //   key: "note",
      //   width: "100",
      //   align: "left",
      //   slot: "note"
      // });
      // if (this.showNoteTime || this.tableType === "note") {
      //   columns.push({
      //     title: "备注时间",
      //     key: "noteTime",
      //     width: 108,
      //     align: "center",
      //     sortable: true
      //   });
      // }
      columns.push({
        title: '操作',
        slot: 'action',
        width: 260,
        align: 'right'
      })

      return columns
    }
  },
  created() {
    // 在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem("store")) {
    //   this.$store.replaceState(
    //     Object.assign(
    //       {},
    //       this.$store.state,
    //       JSON.parse(sessionStorage.getItem("store"))
    //     )
    //   );
    // }
    // 在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload", () => {
    //   sessionStorage.setItem("store", JSON.stringify(this.$store.state));
    // });
    this.getInfos(this.fromPage, this.rowNums)
    this.getInfoTotal()
  },
  mounted() { },
  methods: {
    async getLink(link) {
      console.log('link', link)
      const res = await check58Call58()
      console.log('res', res)
      if (!res.data.data) {
        window.open(link)
      } else {
        window.open(res.data.data.url)
      }
    },
    async fixMobile(row) {
      this.curRow = row
      this.showFixPhone = true
      this.formInline.mobile = null

      console.log('row', row)
      const { data } = await getFixList({
        info_id: row.id
      })
      console.log('data', data)
      this.mobileHistoryList = data.data
    },

    onOk() {
      console.log('this.newMobile', this.formInline.mobile)
      if (!this.formInline.mobile) return

      this.updateMobile(this.curRow)
    },

    onCancel: () => {
      this.showFixPhone = false
    },

    async getMobile(row) {
      console.log('row=======', row)
      const { data } = await getMobile({
        infoId: row.info_id
      })
      this.mobile = data.data.Phone
      this.$Modal.confirm({
        render: h => {
          return h('div', [
            // 创建节点div
            h(
              'div',
              {
                // 创建标题区域子节点div,设置样式，创建其子节点icon和span
                class: {
                  'modal-title': true
                },
                style: {
                  display: 'flex',
                  height: '42px',
                  alignItems: 'center'
                }
              },
              [
                h('Icon', {
                  props: {
                    type: 'ios-alert'
                  },
                  style: {
                    width: '28px',
                    height: '28px',
                    fontSize: '28px',
                    color: '#f90'
                  }
                }),
                h('span', {
                  style: {
                    marginLeft: '12px',
                    fontSize: '16px',
                    color: '#17233d',
                    fontWeight: 500
                  },
                  domProps: {
                    innerHTML: '虚拟号：'
                  }
                })
              ]
            ),
            h(
              'div',
              {
                // 创建内容区div节点，设置样式
                class: {
                  'modal-content': true
                },
                style: {
                  paddingLeft: '40px'
                }
              },
              [
                h('p', {
                  // 创建content的子节点 p标签、label标签、RadioGroup
                  style: {
                    marginBottom: '15px'
                  },
                  domProps: {
                    innerHTML: `${this.mobile}`
                  }
                }),
                h('p', {
                  // 创建content的子节点 p标签、label标签、RadioGroup
                  style: {
                    marginBottom: '15px',
                    color: 'blue'
                  },
                  domProps: {
                    innerHTML: `<a href=${row.link} target="_blank">点击打开详情</a>`
                  }
                }),
                h('label', {
                  style: {
                    marginRight: '10px'
                  },
                  domProps: {
                    innerHTML: '真实手机号'
                  }
                }),

                h('Input', {
                  props: {
                    value: '',
                    autofocus: true,
                    placeholder: '请输入真实手机号'
                  },
                  on: {
                    input: val => {
                      this.newMobile = val
                    }
                  }
                })
              ]
            )
          ])
        },

        onOk: () => {
          console.log('this.newMobile', this.newMobile)
          if (!this.newMobile) return
          this.updateInfo(row)
        }
      })
    },

    async updateInfo(row) {
      this.loading = true

      const { data } = await saveMobile({
        id: row.id,
        mobile: this.newMobile,
        // userFixTime: row.user_fix_time,
        userName: this.$store.state.user.userName
      })
      this.loading = false
      if (data.ret !== 200) {
        return this.$Message.error(data.msg)
      }

      this.$Message.success('保存成功')
      if (this.searchValue) {
        this.handleSearch()
      } else {
        this.reload()
      }
    },

    async updateMobile(row) {
      this.loading = true

      const { data } = await saveMobile({
        id: row.id,
        mobile: this.formInline.mobile,
        userName: this.$store.state.user.userName
      })
      this.loading = false
      if (data.ret !== 200) {
        return this.$Message.error(data.msg)
      }

      this.$Message.success('保存成功')
      if (this.searchValue) {
        this.handleSearch()
      } else {
        this.reload()
      }
    },

    getListBynote() {
      this.loading = true
      let userId = this.$store.state.user.userId
      this.$axios
        .request({
          url: 'caiji/?s=info2.getlistwithnote&userId=' + userId,
          method: 'GET'
        })
        .then(json => {
          console.log(json)

          this.tableData = json.data.data
          this.tableType = 'note'
          this.loading = false
        })
    },

    getBlackList() {
      this.loading = true
      let userId = this.$store.state.user.userId
      this.$axios
        .request({
          url: 'caiji/?s=info2.getlistwithblack&userId=' + userId,
          method: 'GET'
        })
        .then(json => {
          console.log(json)
          this.tableData = json.data.data
          this.tableType = 'black'
          this.loading = false
        })
    },

    note() {
      this.showExpand = true
    },

    reload() {
      this.getInfos(this.fromPage, this.rowNums)
      this.getInfoTotal()
      this.showFooter = true
      this.tableType = 'default'
    },

    gettime(value, row) {
      return row.time.indexOf(value) > -1
    },

    getInfoTotal() {
      this.$axios
        .request({
          url: 'caiji/?s=info2.getlistcount',
          method: 'GET'
        })
        .then(json => {
          console.log(json)
          this.infoTotal = Number(json.data.data)
        })
    },
    getsearchTotal(datas) {
      this.$axios
        .request({
          url: 'caiji/?s=info2.searchCount',
          data: datas,
          method: 'POST'
        })
        .then(json => {
          console.log(json)
          this.infoTotal = json.data.data
            ? Number(json.data.data[0].number)
            : 0
        })
    },

    getInfos(fromPage, rowNums) {
      this.loading = true
      let userId = this.$store.state.user.userId
      console.log('userId', userId)
      this.$axios
        .request({
          url:
            'caiji/?s=info2.getlist&userId=' +
            userId +
            '&from=' +
            fromPage +
            '&nums=' +
            rowNums,
          method: 'GET'
        })
        .then(json => {
          console.log(json)
          json.data.data.forEach(item => {
            item.isClick = false
          })
          this.tableType = 'default'
          this.tableData = json.data.data

          this.loading = false
        })
    },

    handleSelectAll(status) {
      this.$refs.selection.selectAll(status)
    },

    selectme(data) {
      console.log('data', data)
      const token = this.$store.state.user.token
      if (token) {
        this.$axios
          .request({
            url: 'caiji/?s=info2.edit',
            data: {
              selected: 1,
              source_id: 1,
              id: data.id,
              token: token
            },
            method: 'POST'
          })
          .then(json => {
            console.log(json)
            if (json.data.ret !== 200) {
              this.$Message.error(json.data.msg)
            } else {
              this.$Message.success(
                '已进行了保护,请在已保护信息里查看,注意保护的截止时间!'
              )
              // this.getInfos(this.fromPage, this.rowNums);
              // 开启动作后刷新页面
              // if (this.tableType === 'default') {
              //   this.reload();
              // } else if (this.tableType === 'note') {
              //   this.getListBynote();
              // } else if (this.tableType === 'search') {
              //   this.handleSearch();
              // } else if (this.tableType === 'black') {
              //   this.getBlackList();
              // }
            }
          })
      } else {
        alert('你的用户没有登录或已过期，请重新登录！')
      }
    },
    goto(data) {
      console.log('gotOdata', data)
      window.open(data.link)
      data.isClick = true
    },
    selectmeBatch(data) {
      console.log('data', data)
    },
    changePage(pageNumber) {
      // this.fromPage = pageNumber;
      // TODO:根据tableType来调用不同的方法带分页功能
      this.fromPage = pageNumber
      if (this.tableType === 'search') {
        this.handleSearch()
      } else {
        this.getInfos(pageNumber, this.rowNums)
      }

      // console.log('下页数据', pageNumber);
    },
    changePageSize(pageSize) {
      // console.log('pageSize', pageSize)
      this.rowNums = pageSize
      // console.log('frompage', this.fromPage)
      this.getInfos(this.fromPage, this.rowNums)
    },
    handleClear(e) {
      // if (e.target.value === '') this.insideTableData = this.value;
    },
    handleSearch() {
      let skey = this.searchKey
      let svalue = this.searchValue
      let data = {}
      let tt = null
      this.tableType = 'search'
      console.log('skey============', skey)
      if (skey === 'area') {
        if (!this.isAutoRefreshed) {
          if (tt) {
            clearTimeout(tt)
          }
        } else {
          let _this = this
          tt = setTimeout(() => {
            _this.handleSearch()
          }, this.refreshTime)
        }
      } else {
        this.isAutoRefreshed = false
        if (tt) {
          clearTimeout(tt)
        }
      }
      if (skey) data[skey] = svalue
      data['userId'] = this.$store.state.user.userId
      data['from'] = this.fromPage
      data['nums'] = this.rowNums
      console.log('searchkey', data)
      this.loading = true
      this.getsearchTotal(data)
      this.$axios
        .request({
          url: 'caiji/?s=info2.search',
          data: data,
          method: 'POST'
        })
        .then(json => {
          // console.log('search结果：', json);
          this.loading = false
          this.tableData = json.data.data
          this.showFooter = true
        })
    },
    noteedit(row, index) {
      this.editNote = row.note
      this.editIndex = index
    },
    notesave(row) {
      if (!this.editNote) {
        this.editIndex = -1
      } else {
        row.note = this.editNote

        this.editIndex = -1

        console.log(row)
        let userId = this.$store.state.user.userId
        let postData = {
          phone: row.phone,
          note: row.note,
          userId: userId
        }
        this.$axios
          .request({
            url: 'caiji/?s=note2.save',
            data: postData,
            method: 'POST'
          })
          .then(json => {
            console.log('noteSave', json)
            let jsonData = json.data
            if (jsonData.ret === 200) {
              this.$Message.success('备注保存成功,请进入已备注的信息中查看')
              // if (this.tableType === 'default') {
              //   this.reload();
              // } else if (this.tableType === 'note') {
              //   this.getListBynote();
              // } else if (this.tableType === 'search') {
              //   this.handleSearch();
              // } else if (this.tableType === 'black') {
              //   this.getBlackList();
              // }
            } else {
              this.$Message.error(jsonData.msg)
            }
          })
      }
    },
    blacksave(row) {
      console.log(row)
      let userId = this.$store.state.user.userId
      let postData = {
        phone: row.phone,
        userId: userId,
        note: '黑名单'
      }
      this.$axios
        .request({
          url: 'caiji/?s=note2.save',
          data: postData,
          method: 'POST'
        })
        .then(json => {
          console.log('blacklist', json)
          let jsonData = json.data
          if (jsonData.ret === 200) {
            this.$Message.success('信息已经列入黑名单!')
            // if (this.tableType === 'default') {
            //   this.reload();
            // } else if (this.tableType === 'note') {
            //   this.getListBynote();
            // } else if (this.tableType === 'search') {
            //   this.handleSearch();
            // } else if (this.tableType === 'black') {
            //   this.getBlackList();
            // }
          } else {
            this.$Message.error(jsonData.msg)
          }
        })
        .catch(err => {
          this.$Message.success('发生异常!' + err.response.data.msg)
        })
    },
    blacksaveDel(row) {
      let postData = {
        isBlack: 1,
        id: row.id
      }
      this.$Modal.confirm({
        title: '重要提示',
        content: '信息回收后，所有人将不可见，确定回收吗？',
        onOk: () => {
          this.$axios
            .request({
              url: 'caiji/?s=info2.edit',
              data: postData,
              method: 'POST'
            })
            .then(json => {
              console.log('blacklist', json)
              let jsonData = json.data
              if (jsonData.ret === 200) {
                this.$Message.success('信息已经进入回收站，所有人不可见!')
                // if (this.tableType === 'default') {
                //   this.reload();
                // } else if (this.tableType === 'note') {
                //   this.getListBynote();
                // } else if (this.tableType === 'search') {
                //   this.handleSearch();
                // } else if (this.tableType === 'black') {
                //   this.getBlackList();
                // }
              } else {
                this.$Message.error(jsonData.msg)
              }
            })
            .catch(err => {
              this.$Message.success('发生异常!' + err.response.data.msg)
            })
        },
        onCancel: () => { }
      })
    },
    unblacksave(row) {
      console.log(row)
      let userId = this.$store.state.user.userId
      let postData = {
        phone: row.phone,
        userId: userId,
        note: 'null'
      }
      this.$axios
        .request({
          url: 'caiji/?s=note2.save',
          data: postData,
          method: 'POST'
        })
        .then(json => {
          console.log('blacklist', json)
          let jsonData = json.data
          if (jsonData.ret === 200) {
            this.$Message.success('信息已经恢复到正常列表中!')
            // if (this.tableType === 'default') {
            //   this.reload();
            // } else if (this.tableType === 'note') {
            //   this.getListBynote();
            // } else if (this.tableType === 'search') {
            //   this.handleSearch();
            // } else if (this.tableType === 'black') {
            //   this.getBlackList();
            // }
          } else {
            this.$Message.error(jsonData.msg)
          }
        })
    }
  }
}
</script>

<style scoped>
.notewithother {
  border: 1px solid red;
}

.note-input {
  width: 100%;
}

.black-button {
  background: #141414;
}

a {
  width: 100%;
  height: 100%;
}

a:link {
  color: white;
}

a:visited {
  color: #ff9900;
  /* color: white; */
  background: grey;
  width: 100%;
  height: 100%;
  z-index: 10;
  position: absolute;
}

a:hover {
  display: block;
  color: white;
  background: grey;
  width: 100%;
  height: 100%;
  z-index: 10;
}

.refresh {
  width: auto;
  height: 24px;
  line-height: 24px;
  margin-left: 20px;
}

.mobile-fixed {
  width: 100%;
  display: flex;

  justify-content: space-evenly;
  align-items: center;
}

.red {
  color: red;
}
</style>
